// HPS list: GET /hps/getall-list-hps-tad query builder, stat cards and the
// Excel/CSV export. Fetch and download helpers are shared with the Plan &
// Procurement list.

import { api } from '../../../config';
import { formatDateToDDMMYYYY } from '../../../utils/dateformatter';
import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const HPS_PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// Column id -> SortBy value. Ids without an entry are sent as-is.
export const HPS_SORT_FIELDS = {
  procurementnumber: 'procurementnumber',
  titleprocurement: 'titleprocurement',
  procurementtype: 'procurementtype',
  description: 'description',
  isProcurementCompleted: 'isProcurementCompleted',
};

export const DEFAULT_SORT_FIELD = 'hpsRequestDate';

export const isHpsAvailable = row => row?.statusHPS2 === 'Available';

export const buildHpsListUrl = ({
  currentPage,
  rowsPerPage,
  procurementTypeHeader,
  search,
  statusValue,
  sortField,
  sortDirection,
}) => {
  const params = new URLSearchParams();
  params.set('PageNumber', String(currentPage));
  params.set('PageSize', String(rowsPerPage));
  if (procurementTypeHeader) {
    params.set('ProcurementTypeHeader', procurementTypeHeader);
  }
  if (search?.trim()) params.set('Search', search.trim());
  if (sortField) {
    params.set('SortBy', sortField);
    params.set('IsDescending', sortDirection === 'desc' ? 'true' : 'false');
  }
  if (statusValue) params.set('StatusHps2', statusValue);
  return `${api.API_URL}/hps/getall-list-hps-tad?${params.toString()}`;
};

// Excel/LibreOffice mengeksekusi sel yang diawali karakter ini sebagai formula.
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

const escapeCsvCell = value =>
  typeof value === 'string' && FORMULA_PREFIX.test(value) ? `'${value}` : value;

const toExportRow = row => ({
  'ID Proc': row.procurementNumber || '',
  'Submitted Date': formatDateToDDMMYYYY(row.hpsRequestDate) || '',
  'HPS No': row.hpsRequestNumber || '',
  Title: row.titleProcurement || '',
  'Proc Type': HPS_PROCUREMENT_TYPE_MAP[row.procurementType] || '',
  Product: row.productType?.name || '',
  'Product Type':
    getListProductTypeLabel(row, row.productType?.description) || '',
  Description: row.description || '',
  Status: row.statusHPS2 || '',
});

const toExportRowEscaped = row =>
  Object.fromEntries(
    Object.entries(toExportRow(row)).map(([key, value]) => [
      key,
      escapeCsvCell(value),
    ])
  );

// Escaping hanya untuk CSV; di XLSX prefix apostrof akan tampil literal.
export const exportHpsList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(format === 'csv' ? toExportRowEscaped : toExportRow), {
    format,
    prefix: 'Hps',
    sheetName,
  });
